import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface ActiveSessionsWarningProps {
  isSubmitting: boolean;
  error: string | null;
  onContinueAndLogoutOthers: () => void;
}

const ActiveSessionsWarning: React.FC<ActiveSessionsWarningProps> = ({
  isSubmitting,
  error,
  onContinueAndLogoutOthers,
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-100 via-white to-blue-100 flex items-center justify-center p-6">
      <div className="w-full max-w-4xl bg-white rounded-2xl shadow-2xl border border-gray-200">
        <div className="m-6 p-4 rounded-lg border border-red-200 bg-red-50 text-red-900 flex items-center gap-3">
          <AlertTriangle className="w-5 h-5" />
          <p className="font-semibold">
            Security warning: your account is already active in another session.
          </p>
        </div>

        <div className="px-8 pb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-3">Before you continue</h2>
          <ul className="list-disc pl-5 space-y-2 text-gray-700">
            <li>We detected that this account is currently signed in on another browser or device.</li>
            <li>For account safety, only one active session is allowed at a time.</li>
            <li>To proceed, you must end the other active session.</li>
            <li>If this was not you, update your password after signing in.</li>
          </ul>

          {error && (
            <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700">
              {error}
            </div>
          )}

          <div className="mt-6">
            <button
              onClick={onContinueAndLogoutOthers}
              disabled={isSubmitting}
              className="px-5 py-2.5 rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {isSubmitting ? 'Ending other session...' : 'Continue and log out other session'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveSessionsWarning;
